import './Nav.scss';
import { Link } from 'react-router-dom'

export default function Nav()
{
    return (
        <nav>
            <div className="NavBar">
                <div className='link'><Link to="/">Acceuil</Link></div>
                <div className='link'><Link to="/Cours">Cours</Link></div>
                <div className='link'><Link to="/Docs">Documentation</Link></div>
                <div className='link'><Link to="/Machines">Machines</Link></div>
                <div className='link'><Link to="/Hardware">Hardware</Link></div>
                <div className='link'><Link to="/Maj">Mise à jour</Link></div>
                <div className='link'><Link to="/About">A propos</Link></div>
            </div>
        </nav>

    )
}